<template>
  <div class="container pt-5 pb-6">

    <!-- <div class="buttons pb-3">
      <button
        class="button is-primary">
        Make an Inventory Adjustment
      </button>
    </div> -->

    <div class="tabs mb-5">
      <ul>
        <li 
          @click="active = 'product'"
          :class="{ 'is-active': active == 'product' }">
          <a>Product Inventory</a>
        </li>
        <li
           @click="active = 'project'" 
          :class="{ 'is-active': active == 'project' }">
          <a>Project Inventory</a>
        </li>
      </ul>
    </div>

    <v-fade-transition mode="out-in">
      <central-inventory-list v-if="active == 'product'"/>
      <project-inventory-list v-if="active == 'project'"/>
    </v-fade-transition>
  </div>
</template>

<script>
import CentralInventoryList from '@/components/inventory/CentralInventoryList'
import ProjectInventoryList from '@/components/inventory/ProjectInventoryList'
import VFadeTransition from '@/components/transitions/VFadeTransition'

export default {
  components: {
    CentralInventoryList,
    ProjectInventoryList,
    VFadeTransition
  },
  data() {
    return {
      active: 'product'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>